import React, { useContext, useLayoutEffect } from 'react';
import { systemCode, xs_languageCode } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { UserContext } from '../../data/betslip/UserConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { openPopup } from '../../data/sport-utils';
import { classIf, getConfiguration, getMybetsPage, loadSessionToken } from '../../data/utils';
import { getLabel } from '../../data/labels';
import Coupon from './Coupon';
import BetslipSettings from './BetslipSettings';
import FastbetToggle from '../fastbet/FastbetToggle';
import { disableBetslipScrollbar, disableBetslipScrollObserver, enableBetslipScrollbar } from '../../betslip-observers';
import { CounterMyBets } from './CounterMyBets';

function openMyBets() {
    const mybetsPage = getMybetsPage(false);
    const url = `${process.env.PUBLIC_URL}${mybetsPage}`;
    openPopup(`${url}?token=${loadSessionToken()}&language=${xs_languageCode}&systemCode=${systemCode}`, getLabel('general.mybets'), 500, 800);
}

export default function BetslipContent(props) {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    const shopContext = useContext(ShopContext);
    const userContext = useContext(UserContext);
    const betslipData = betslipContext.getBetslipData();

    let reservations = betslipContext.getReservations();
    reservations = reservations == null ? [] : reservations;
    const user = userContext.getUser();
    let wageringMessage = null;
    if (user?.logged) {
        if (user.freebetCount > 0 && user.funbonusCount == 0) {
            wageringMessage = getLabel('freebet.enabled');
        }
        else if (user.freebetCount == 0 && user.funbonusCount > 0) {
            wageringMessage = getLabel('funbonus.enabled');
        }
        else if (user.freebetCount > 0 && user.funbonusCount > 0) {
            wageringMessage = getLabel('freebet_funbonus.enabled');
        }
    }

    const showReservationBox = betslipContext.isReservationBoxShown();
    function toggleReservationBox() {
        betslipContext.toggleReservationBox();
    }

    function showBetslipCoupon(keyCoupon) {
        betslipContext.changeCoupon(keyCoupon);
    }

    function toggleBetslipScrollableProp() {
        betslipContext.toggleScrollable();
    }

    function toggleBetslipSettings() {
        betslipContext.toggleBetslipSettings();
    }

    const isPinned = betslipContext.isScrollable();
    useLayoutEffect(() => {
        if (isPinned) {
            enableBetslipScrollbar();
        } else {
            disableBetslipScrollbar();
        }

        return () => {
            disableBetslipScrollObserver();
        }
    }, [isPinned]);

    let betslipTitle = getLabel('carrello.box_title') + " " + betslipData.selectedCoupon;
    if (betslipContext.isBetBuilder()) {
        betslipTitle = getLabel('betbuilder.betslip_title');
    }

    return (
        <div className="betslip-content">
            {conf.iwh && <div className='line-betslip-wrapper'><div className='line-betslip-wh'></div></div>}
            <div className="maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
                <div className="titolo-widget-stampa">
                    <div>
                        <span className='titolo__coupon'>{conf.iwh ? 'Schedina' : betslipTitle} </span>
                    </div>
                    <div className="toolbox-schedina">
                        {!shopContext.enabled &&
                            <div id="settings-dropdown-toggle" onClick={() => toggleBetslipSettings()} className="tasto-abilita-carrello-scrollable pointer">
                                <i className="fas fa-cog"></i>
                            </div>
                        }
                        <div onClick={() => toggleBetslipScrollableProp()} className="tasto-abilita-carrello-scrollable pointer"
                            data-carrello-scrollable-abilitato={betslipContext.isScrollable()}>
                            <i className="fas fa-thumbtack"></i>
                        </div>
                        {
                            !betslipContext.isBetBuilder() && <>
                                <div id="allarga-coupon">
                                    <i className="fas fa-expand-arrows-alt pointer" data-toggle="tooltip" data-placement="top" title="" data-original-title="Allarga la schedina"></i>
                                </div>
                                <div className="pointer tasto-stringi-dx" onClick={props.toggleBetslip}>
                                    <i className="fas fa-chevron-right" data-toggle="tooltip" data-placement="top" title="" data-original-title="Nascondi la schedina"></i>
                                </div>
                                {conf.mybbp && user && user.logged && conf.iwh &&
                                    <CounterMyBets />
                                }
                                <div className={"stampa-schedina pointer toggleReservationBox" + classIf(showReservationBox, 'shown')} onClick={() => toggleReservationBox(!showReservationBox)}>
                                    <i className="fas fa-ticket-alt pointer" data-toggle="tooltip" data-placement="top" title="" data-original-title="Prenotazioni"></i>
                                    <span id="reservation-number" className="badge bordo-rotondo bg-colore-1 bianco">{reservations.length}</span>
                                </div>
                            </>
                        }
                    </div>
                </div>
                {betslipContext.isBetslipSettingsVisible() &&
                    <BetslipSettings />
                }
                <div className="betslip-riga-fastbet" >
                    {conf.anbe && !betslipContext.isBetBuilder() &&
                        <FastbetToggle />
                    }
                    {conf.mybbp && user && user.logged &&
                        <div className="mybets-button-container pointer" onClick={openMyBets}>
                            <span>{getLabel('general.mybets')}</span>
                            <div id="mybetsButton" className="bottone pointer"  />
                        </div>
                    }
                </div>
                {wageringMessage &&
                    <div className={"adviseFreebetContainer"}>
                        <span className={"iconContainer"}><i className={"fas fa-thumbs-up"} /></span>
                        <span className={"textContainer"}>{wageringMessage}</span>
                    </div>
                }
            </div>
            <div className={"betslipEffectiveContainer"}>
                {
                    !betslipContext.isBetBuilder() &&
                    <div className="scAggiuntive d-flex justify-content-around align-intems-center bg-colore-1 nav nav-tabs"
                        role="tablist"
                        id="betslip-selectors">
                        {Object.keys(betslipData.coupons).map(function (key) {
                            return (
                                /* HREF IS DISABLED 'CAUSE THE COUPON WILL BE SHOWN THANKS TO REACT STATE CHANGE: BOOTSTRAP IS USELESS HERE */
                                <a className={"pointer scAggiuntiva" + classIf(key === betslipData.selectedCoupon, 'active')}
                                    data-toggle="tab"
                                    role="tab" aria-selected={key === '1' ? "true" : "false"}
                                    id={"couponSelectorNumber" + key}
                                    key={"couponSelectorKey" + key}
                                    onClick={() => showBetslipCoupon(key)}>
                                    {key}
                                    {betslipData.coupons[key].selections.length > 0 &&
                                        <span>&bull;</span>
                                    }
                                </a>
                            )
                        })}
                    </div>
                }
                {/* [/BETSLIP_SELECTORS]  */}
                {
                    betslipContext.isBetBuilder() ?
                        <Coupon showable={"true"} couponKey={'1'} key={"couponKey1"} />
                        :
                        <div className="tab-content tabelleSchedineNumerate">
                            {Object.keys(betslipData.coupons).map(key => {
                                const showable = key === betslipData.selectedCoupon;
                                if (showable) {
                                    return (<Coupon showable={"true"} couponKey={key} key={"couponKey" + key} />)
                                } else {
                                    return null
                                };
                            })}
                        </div>
                }

            </div>
        </div>
    );
}
